export default __webpack_public_path__ + "static/media/solucionarte_logo-15.53099103.png";